import * as types from "./actionTypes"

export function showNotification(data) {
    return {
        type: types.SHOW_NOTIFICATION,
        payload: data,
    }
}
export function setNotification() {
    return {
        type: types.SET_NOTIFICATION,
    }
}
